import React from 'react';
import styled from 'styled-components';

import { Image } from '@lt/components';

import {
  Info,
  Target,
  Checkmark,
  Update,
  Settings,
  Support,
  Card,
} from '@lt/components/icons-react/home_lt_promo';

import seaviewPng from 'src/images/home_lt_promo/seaview.png';
import seaviewWebp from 'src/images/home_lt_promo/seaview.webp';

import promoPng from 'src/images/home_lt_promo/promo.png';
import promoWebp from 'src/images/home_lt_promo/promo.webp';

import historyPng from 'src/images/home_lt_promo/history.png';
import historyWebp from 'src/images/home_lt_promo/history.webp';

import crownPng from 'src/images/home_lt_promo/crown.png';
import crownWebp from 'src/images/home_lt_promo/crown.webp';

import messangerPng from 'src/images/home_lt_promo/messanger.png';
import messangerWebp from 'src/images/home_lt_promo/messanger.webp';

import { useTranslation } from '@lt/localization';

const HomeLtBottomPromo = ({ isMobile = false }) => {
  const { t } = useTranslation();

  return (
    <Container $isMobile={isMobile}>
      <AboutContainer $isMobile={isMobile}>
        <AboutInnerContainer $isMobile={isMobile}>
          <AboutHeading $isMobile={isMobile}>
            <StyledInfo />
            {t('home_lt_bottom_promo.company.heading')}
          </AboutHeading>
          <Description>
            {t('home_lt_bottom_promo.company.description')}
          </Description>
        </AboutInnerContainer>

        <AboutInnerContainer $isMobile={isMobile}>
          <AboutHeading $isMobile={isMobile}>
            <StyledTarget />
            {t('home_lt_bottom_promo.mission.heading')}
          </AboutHeading>
          <Description>
            {t('home_lt_bottom_promo.mission.description')}
          </Description>
        </AboutInnerContainer>
      </AboutContainer>

      <Delimeter />

      <Heading>
        <StyledCheckmark />
        {t('home_lt_bottom_promo.transparency.heading')}
      </Heading>
      <MiddleDescription $isMobile={isMobile}>
        {t('home_lt_bottom_promo.transparency.description')}
      </MiddleDescription>

      <FeatureHeading $isMobile={isMobile}>
        {t('home_lt_bottom_promo.features.heading')}
      </FeatureHeading>

      <FeaturesContainer $isMobile={isMobile}>
        <Feature $isMobile={isMobile}>
          <StyledUpdate />
          {t('home_lt_bottom_promo.features.items.integration')}
        </Feature>
        <Feature $isMobile={isMobile}>
          <StyledSettings />
          {t('home_lt_bottom_promo.features.items.filters')}
        </Feature>
      </FeaturesContainer>
      <FeaturesContainer $isMobile={isMobile}>
        <Feature $isMobile={isMobile}>
          <StyledSupport />
          {t('home_lt_bottom_promo.features.items.support')}
        </Feature>
        <Feature $isMobile={isMobile}>
          <StyledCard />
          {t('home_lt_bottom_promo.features.items.payments')}
        </Feature>
      </FeaturesContainer>

      <FeatureHeading $isMobile={isMobile}>
        {t('home_lt_bottom_promo.get_instruction.still_thinking')}
        <br />
        {t('home_lt_bottom_promo.get_instruction.we_do')}{' '}
        <InstructionLink href="https://promo.level.travel">
          {t('home_lt_bottom_promo.get_instruction.link')}
        </InstructionLink>
        {'. '}
        {t('home_lt_bottom_promo.get_instruction.hurry_up')}
      </FeatureHeading>

      <Delimeter />

      <Heading>{t('home_lt_bottom_promo.articles_links.heading')}</Heading>
      <ArticlesContainer $isMobile={isMobile}>
        <ArticleLink
          href="https://promo.level.travel/how-to-buy"
          target="_blank"
          $isMobile={isMobile}
        >
          <ArticleImage
            src={seaviewWebp}
            fallback={seaviewPng}
            alt="how to buy"
            $isMobile={isMobile}
          />
          <ArticleContent $isMobile={isMobile}>
            {t('home_lt_bottom_promo.articles_links.how_to_buy')}
          </ArticleContent>
        </ArticleLink>
        <ArticleLink
          href="https://promo.level.travel/how-to-find"
          target="_blank"
          $isMobile={isMobile}
        >
          <ArticleImage
            src={promoWebp}
            fallback={promoPng}
            alt="how to find"
            $isMobile={isMobile}
          />
          <ArticleContent $isMobile={isMobile}>
            {t('home_lt_bottom_promo.articles_links.how_to_find')}
          </ArticleContent>
        </ArticleLink>
        <ArticleLink
          href="https://promo.level.travel/paylate"
          target="_blank"
          $isMobile={isMobile}
        >
          <ArticleImage
            src={historyWebp}
            fallback={historyPng}
            alt="paylate"
            $isMobile={isMobile}
          />
          <ArticleContent $isMobile={isMobile}>
            {t('home_lt_bottom_promo.articles_links.paylate')}
          </ArticleContent>
        </ArticleLink>
      </ArticlesContainer>
      <ArticlesContainer $isMobile={isMobile}>
        <ArticleLink
          href="https://promo.level.travel/vip"
          target="_blank"
          $isMobile={isMobile}
        >
          <ArticleImage
            src={crownWebp}
            fallback={crownPng}
            alt="vip"
            $isMobile={isMobile}
          />
          <ArticleContent $isMobile={isMobile}>
            {t('home_lt_bottom_promo.articles_links.vip')}
          </ArticleContent>
        </ArticleLink>
        <ArticleLink
          href="https://level.travel/media/category/inspiration"
          target="_blank"
          $isMobile={isMobile}
        >
          <ArticleImage
            src={messangerPng}
            fallback={messangerWebp}
            alt="inspiration"
            $isMobile={isMobile}
          />
          <ArticleContent $isMobile={isMobile}>
            {t('home_lt_bottom_promo.articles_links.inspiration')}
          </ArticleContent>
        </ArticleLink>
      </ArticlesContainer>
      <Delimeter />
    </Container>
  );
};

const Container = styled.div<{ $isMobile?: boolean }>`
  padding: 20px;
`;

const Heading = styled.div`
  font-size: 24px;
  margin-top: 20px;
  line-height: 33px;

  vertical-align: baseline;
  text-align: center;
`;

const AboutContainer = styled.div<{ $isMobile?: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
        display: block;
  `
      : `
        display: flex;
  `}
`;

const AboutInnerContainer = styled.div<{ $isMobile?: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
    width: 580px;
    padding-left: 30px;
  `}
`;

const AboutHeading = styled(Heading)<{ $isMobile?: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
    text-align: left;
  `}
`;

const Description = styled.div`
  margin: 20px 0;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
`;

const MiddleDescription = styled(Description)<{ $isMobile?: boolean }>`
  line-height: 24px;
  margin: 20px auto;
  color: #4a4a4a;

  ${({ $isMobile }) =>
    !$isMobile &&
    `
    text-align: center;
    max-width: 856px;
  `}
`;

const Delimeter = styled.hr`
  border: 0;
  width: 190px;
  height: 1px;
  background: #cacaca;
  margin: 30px auto;
`;

const FeaturesContainer = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
    display: flex;
    max-width: 1080px;
    margin: 0 auto;
  `}
`;

const FeatureHeading = styled.div<{ $isMobile: boolean }>`
  font-size: 18px;
  margin: 15px 0;
  line-height: 26px;

  ${({ $isMobile }) =>
    !$isMobile &&
    `
    text-align: center;
  `}
`;

const Feature = styled.div<{ $isMobile: boolean }>`
  padding: 10px 20px;
  font-size: 16px;
  line-height: 22px;
  display: flex;

  ${({ $isMobile }) =>
    !$isMobile &&
    `
    padding: 10px 0 20px 40px;
    width: 510px;
  `}
`;

const InstructionLink = styled.a`
  color: #4a4a4a;
`;

const ArticlesContainer = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
    margin: 10px auto 0;
    display: inline-flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  `}
`;

const ArticleLink = styled.a<{ $isMobile: boolean }>`
  display: flex;
  vertical-align: middle;
  text-decoration: none;
  margin: 6px 11px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
    margin: 20px 0;
  `}
`;

const ArticleContent = styled.div<{ $isMobile: boolean }>`
  vertical-align: middle;
  font-size: 18px;
  color: #4a4a4a;
  transform: translate(0%, 15%);

  ${({ $isMobile }) =>
    $isMobile
      ? `
    width: 250px;
  `
      : `
    line-height: 30px;
  `}
`;

const ArticleImage = styled(Image)<{ $isMobile: boolean }>`
  width: 41px;
  height: 41px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
    width: 45px;
    height: 45px;
    margin: 0 25px 0 20px;
  `}
`;

const HeadingIconStyles = `
  width: 33px;
  height: 33px;
  margin-right: 10px;

  position: relative;
  vertical-align: top;
  display: inline-block;

  path {
    fill: #3fa9f5;
  }
`;

const StyledInfo = styled(Info)`
  ${HeadingIconStyles}
`;

const StyledTarget = styled(Target)`
  ${HeadingIconStyles}
`;

const StyledCheckmark = styled(Checkmark)`
  ${HeadingIconStyles}
`;

const FeatureIconStyles = `
  display: inline-block;
  min-width: 27px;
  height: 27px;
  margin-right: 8px;
`;

const StyledUpdate = styled(Update)`
  ${FeatureIconStyles}
`;

const StyledSettings = styled(Settings)`
  ${FeatureIconStyles}
`;

const StyledSupport = styled(Support)`
  ${FeatureIconStyles}
`;

const StyledCard = styled(Card)`
  ${FeatureIconStyles}
`;

export default HomeLtBottomPromo;
